import { Stack } from "@mui/material";

import { ExchangeOffersDialog } from "./components/exchange-offers-dialog/ExchangeOffersDialog";
import { ExchangeTable } from "./components/exchange-table/ExchangeTable";
import { ExchangeFilterBar } from "./components/filter/ExchangeFilterBar";
import { ExchangeHeader } from "./components/header/ExchangeHeader";
import { ExchangeHistoryPanel } from "./components/history-panel/ExchangeHistoryPanel";
import { MakeOfferDialog } from "./components/make-offer-dialog/MakeOfferDialog";
import { NewExchangeRequestDialog } from "./components/new-exchange-request-dialog/NewExchangeRequestDialog";
import { useExchange } from "./hooks/useExchange";

export function Exchange() {
  const {
    view,
    setView,
    counselorId,
    setCounselorId,
    rows,
    isLoading,
    isBusy,
    paginationResetKey,
    isNewRequestOpen,
    openNewRequest,
    closeNewRequest,
    isHistoryOpen,
    openHistory,
    closeHistory,
    offerTarget,
    openMakeOffer,
    closeMakeOffer,
    requestWithdrawOffer,
    offersTarget,
    openOffers,
    closeOffers,
    requestDeleteExchange,
    isDeletingRequest,
  } = useExchange();

  return (
    <Stack spacing={2} sx={{ height: "100%" }} pb={3}>
      <ExchangeHeader onHistoryClick={openHistory} onNewRequestClick={openNewRequest} />
      <ExchangeFilterBar
        view={view}
        onViewChange={setView}
        counselorId={counselorId}
        onCounselorChange={setCounselorId}
      />
      <Stack sx={{ overflow: "auto", flex: 1, minHeight: 0 }}>
        {/* Remounting on a view switch drops a sort on the hidden "Von" column and resets the page. */}
        <ExchangeTable
          key={view}
          rows={rows}
          view={view}
          isLoading={isLoading}
          isBusy={isBusy}
          paginationResetKey={paginationResetKey}
          onMakeOffer={openMakeOffer}
          onWithdrawOffer={requestWithdrawOffer}
          onViewOffers={openOffers}
          onDeleteRequest={requestDeleteExchange}
        />
      </Stack>

      {isNewRequestOpen && <NewExchangeRequestDialog onClose={closeNewRequest} />}
      {/* Mounted per opening so the filters start from their defaults every time. */}
      {isHistoryOpen && <ExchangeHistoryPanel onClose={closeHistory} />}
      {/* Mounted per request so the form starts from fresh defaults every time it opens. */}
      {offerTarget && <MakeOfferDialog exchange={offerTarget} onClose={closeMakeOffer} />}
      {offersTarget && (
        <ExchangeOffersDialog
          exchange={offersTarget}
          onClose={closeOffers}
          onDeleteRequest={requestDeleteExchange}
          isDeletingRequest={isDeletingRequest}
        />
      )}
    </Stack>
  );
}
